import React, { ReactNode } from 'react';
import ReactScrollUp from 'react-scroll-up';

type Props = {
  showUnder?: number;
  children: ReactNode;
};

const style = {
  position: 'fixed',
  cursor: 'pointer',
  transitionDuration: '0.2s',
  transitionTimingFunction: 'linear',
  transitionDelay: '0s',
  bottom: 20,
  right: 20,
  zIndex: 9999,
};

export const ScrollToTop = (props: Props) => {
  const { showUnder = 10, children } = props;
  return (
    <ReactScrollUp style={style} showUnder={showUnder}>
      {children}
    </ReactScrollUp>
  );
};
